import apiClient from '../client'

export interface SubscriptionStatusResponse {
  status: string
  parish_id?: string
  current_period_end?: string | null
  subscription_id?: string | null
  days_until_expiry?: number | null
  warning_sent?: boolean
}

export interface VoucherValidationResponse {
  valid: boolean
  discount_type?: string | null
  discount_percentage?: number | null
  discount_amount?: number | null
}

export interface PrimaryAdminData {
  email: string
  password: string
  first_name: string
  last_name: string
  title?: string
  role_description?: string
  cell_phone?: string
  address?: string
  city?: string
  state?: string
  zip_code?: string
}

export interface CreateCheckoutPayload {
  admin_data: PrimaryAdminData
  voucher_code?: string
  tos_accepted: boolean
}

export const subscriptionsApi = {
  async status(): Promise<SubscriptionStatusResponse> {
    const { data } = await apiClient.get<SubscriptionStatusResponse>('/api/v1/subscriptions/status')
    return data
  },
  async createCheckout(payload: CreateCheckoutPayload): Promise<{ session_id: string; url: string }> {
    const { data } = await apiClient.post('/api/v1/subscriptions/create-checkout', payload)
    return data
  },
  async validateVoucher(code: string): Promise<VoucherValidationResponse> {
    const { data } = await apiClient.post('/api/v1/subscriptions/validate-voucher', { code })
    return data
  },
  async cancel(): Promise<{ message: string; cancelled_at?: string }> {
    const { data } = await apiClient.post('/api/v1/subscriptions/cancel')
    return data
  },
  async renew(voucher_code?: string): Promise<{ session_id: string; url: string }> {
    const { data } = await apiClient.post('/api/v1/subscriptions/renew', { voucher_code: voucher_code || undefined })
    return data
  },
  async createBillingPortal(): Promise<{ url: string }> {
    const { data } = await apiClient.post('/api/v1/subscriptions/billing-portal')
    return data
  },
}


